module.exports = __webpack_public_path__ + "img/Sign_In_Icon.d2fe48a5.svg";